<template lang="pug">
  div
    AppNav
      .row
      .col-lg-6
        h1 {{title}}
        .col-sm-2
        .row
          .col-sm-8
            p
            b Numéro de contrat {{contratById.id}}
            p
            b Médecin remplacé  {{contratById.titulaireByTitulaireId.nom}}
            p
            b Médecin remplaçant  {{contratById.remplacantByRemplacantId.nom}}
            p
            b Dates  {{contratById.setDatesFields}}
        .row
            a(type="button" class='btn btn-primary'  href="/contrats/print/#{id}") Imprimer PDF
            .col-xs-12.col-sm-4 
            #preview
            p.lead= sidebar
</template>
<script>
import AppNav from '../AppNav'
import { 
  CONTRAT_BY_ID_QUERY,
} from '../../constants/graphql'
export default {
  name: 'contrat',
  components: {
      AppNav
  },
  data() {
    return {
        contratById: {},
        title: "Contrat"
    }
  },
  apollo: {
    contratById: {
      query: CONTRAT_BY_ID_QUERY,
      variables() {
        var id = parseInt(this.$route.params.id,10)
        return{
            id
        }
      }
    }
  },
  methods: {     
    returnContrat(){
      console.log(this.contratById)
    }
  }
}
</script>
<style scoped>
body {
  padding-top: 3.5rem; 
}

h1 {
  margin-bottom: 20px;
  padding-bottom: 9px;
  border-bottom: 1px solid #eee;
}

.sidebar {
  position: fixed;
  top: 51px;
  bottom: 0;
  left: 0;
  z-index: 1000;
  padding: 20px;
  overflow-x: hidden;
  overflow-y: auto;
  /* Scrollable contents if viewport is shorter than content. */
  border-right: 1px solid #eee;
}

.sidebar {
    padding-left: 0;
    padding-right: 0;
}

.sidebar .nav {
    margin-bottom: 20px;
}

.sidebar .nav-item {
    width: 100%;
}

.sidebar .nav-item+.nav-item {
    margin-left: 0;
}

.sidebar .nav-link {
    border-radius: 0;
}

.placeholders {
    padding-bottom: 3rem;
}

.placeholder img {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}

select option[data-default] {
    display: none;
}

.medecins-form{
    padding-bottom: 60px;
}
</style>



// WEBPACK FOOTER //
// contrat.vue?784764a0